import React, { Component } from "react";
import { Link } from "react-router-dom";
import { debounce } from "lodash";

import { withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Loader from "../general/Loader";
import { formatCurrency, getLink } from "../../utils/helpers";
import dayjs from "dayjs";

class Compras extends Component {
    state = {
        compras: [],
        compra: {},
        links: null,
        loading: true,
        showCreate: false,
        showEdit: false,
        showSidePopup: false,
    };
    constructor(props) {
        super(props);
        this.sidePopupWrap = React.createRef();
        this.sidePopupOverlay = React.createRef();
    }
    componentDidMount() {
        this.getCompras();
    }
    getCompras = async (url = null) => {
        url = url ? url : "compras?limit=20";
        const compras = await this.props.request(url);

        if (compras.data) {
            this.setState({
                compras: compras.data,
                meta: compras.meta,
                links: compras.links,
                loading: false,
            });
        }
    };
    onFiltroChange = debounce(async (value, filtro) => {
        await this.setState({
            filtros: {
                ...this.state.filtros,
                [filtro]: value,
            },
        });

        let query = Object.keys(this.state.filtros).map((fil) => {
            return `${fil}=${this.state.filtros[fil]}`;
        });

        this.getCompras("compras?limit=20&" + query.join("&"));
    }, 500);
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            compra: {},
        });
    };
    toggleEditModal = (compra) => {
        this.setState({
            showEdit: !this.state.showEdit,
            compra: compra,
        });
    };
    changeItem = (activo) => {
        this.setState({
            activo,
        });
        this.toggleSidePopup(true);
    };
    render() {
        const { compras, showSidePopup, activo, loading } = this.state;

        const itemActivo =
            compras.length > 0
                ? compras.filter((compra) => compra.id === activo)[0]
                : null;

        return (
            <div>
                <div className='page-header'>
                    <h1 className='page-title row'>
                        <span className='col'>Compras</span>
                        <Link
                            to={getLink("/compras/crear")}
                            className='au-btn au-btn-icon au-btn--green au-btn--small'>
                            <i className='zmdi zmdi-plus' />
                            Nueva Compra
                        </Link>
                    </h1>
                </div>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col-md-6'>
                                <label>Buscar</label>
                                <input
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "buscar"
                                        )
                                    }
                                    type='search'
                                    placeholder='Buscar...'
                                    className='form-control'
                                    name='buscar'
                                />
                            </div>
                            <div className='col-md-3'>
                                <label htmlFor='desde'>Desde</label>
                                <input
                                    type='date'
                                    name='desde'
                                    id='desde'
                                    defaultValue={dayjs().format("YYYY-MM-DD")}
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "desde"
                                        )
                                    }
                                />
                            </div>
                            <div className='col-md-3'>
                                <label htmlFor='hasta'>Hasta</label>
                                <input
                                    type='date'
                                    name='hasta'
                                    id='hasta'
                                    defaultValue={dayjs().format("YYYY-MM-DD")}
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "hasta"
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!compras.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            Todavía no hay compras creados.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table
                                        className='table table-data2'
                                        style={{ tableLayout: "fixed" }}>
                                        <thead>
                                            <tr>
                                                <th width='130px'>Fecha</th>
                                                <th>No. Factura</th>
                                                <th>NCF</th>
                                                <th width='200px'>Suplidor</th>
                                                <th>Total</th>
                                                <th>Tipo</th>
                                                <th>Items</th>
                                                <th width='130px'>Vence</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {compras.map((compra) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={compra.id}>
                                                    <td>
                                                        {dayjs(
                                                            compra.fecha
                                                        ).format("DD-MM-YYYY")}
                                                    </td>
                                                    <td>{compra.numero}</td>
                                                    <td>{compra.ncf}</td>
                                                    <td>
                                                        <Link
                                                            to={getLink(
                                                                `/contactos?id=${compra.contactoId}`
                                                            )}>
                                                            {compra.contacto}
                                                        </Link>
                                                    </td>

                                                    <td>
                                                        {formatCurrency(
                                                            compra.total
                                                        )}
                                                    </td>
                                                    <td>{compra.tipo}</td>
                                                    <td>{compra.items}</td>
                                                    <td>
                                                        {compra.fechaVencimiento
                                                            ? dayjs(
                                                                  compra.fechaVencimiento
                                                              ).format(
                                                                  "DD-MM-YYYY"
                                                              )
                                                            : "N/A"}
                                                    </td>
                                                    <td className='text-right'>
                                                        <Link
                                                            to={getLink(
                                                                `/compras/${compra.id}`
                                                            )}
                                                            className='btn btn-secondary'
                                                            type='button'>
                                                            <i className='zmdi zmdi-eye'></i>
                                                        </Link>
                                                        <form
                                                            onSubmit={(e) =>
                                                                this.deleteCompra(
                                                                    e,
                                                                    compra.id
                                                                )
                                                            }>
                                                            {/* <button
                                                                type='submit'
                                                                className='btn btn-danger btn-sm'>
                                                                <i className='fa fa-trash-alt'></i>
                                                            </button> */}
                                                        </form>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getCompras}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {showSidePopup && (
                    <div className='side-popup'>
                        <div
                            onClick={() => this.toggleSidePopup(false)}
                            ref={this.sidePopupOverlay}
                            className='side-popup-background animated fadeIn'></div>
                        <div
                            ref={this.sidePopupWrap}
                            className='side-popup-container animated slideInRight fast'>
                            <h2>
                                {itemActivo.nombre}{" "}
                                <button
                                    className='btn btn-primary float-right compra'
                                    data-toggle='tooltip'
                                    data-placement='top'
                                    title=''
                                    data-original-title='Edit'
                                    onClick={() => {
                                        this.toggleEditModal(itemActivo);
                                    }}>
                                    <i className='zmdi zmdi-edit' />
                                </button>
                            </h2>
                            <br />
                            <table className='table'>
                                <tbody>
                                    <tr>
                                        <td>Encargado</td>
                                        <td>{itemActivo.encargado}</td>
                                    </tr>
                                    <tr>
                                        <td>Tipo</td>
                                        <td>{itemActivo.tipo}</td>
                                    </tr>
                                    <tr>
                                        <td>Teléfono</td>
                                        <td>{itemActivo.telefono}</td>
                                    </tr>
                                    <tr>
                                        <td>Celular</td>
                                        <td>{itemActivo.celular}</td>
                                    </tr>
                                    <tr>
                                        <td>Cédula/RNC</td>
                                        <td>{itemActivo.rnc}</td>
                                    </tr>
                                    <tr>
                                        <td>Dirección</td>
                                        <td>{itemActivo.direccion}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withRequest(Compras);
